<template>
  <div>
    <vue-modal id="passesModal"
               classes="vue-modal-container"
               height="auto"
               name="passes-modal">
      <div class="header">
        <h3>Bérletek</h3>
        <button class="close-modal"
                @click="$modal.hide('passes-modal')">
          <i class="close icon"/>
        </button>
      </div>
      <div class="content">
        <div class="row">
          <table v-if="passes.length > 0"
                 class="ui celled table">
            <thead>
            <tr>
              <th>Bérlet</th>
              <th>Maradék/Összes</th>
              <th>Érvényes</th>
              <th>Vásárolva</th>
              <th>Partner</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="pass in passes">
              <td>{{ pass.name }}</td>
              <td>{{ pass.currentOccasion }}/{{ pass.occasion }}</td>
              <td>{{ getFormattedDate(pass.validUntil) }}</td>
              <td>{{ getFormattedDate(pass.createdAt) }}</td>
              <td>{{ pass.clientName }}</td>
            </tr>
            </tbody>
          </table>
          <div v-else>
            Jelenleg nincs bérlete
          </div>
        </div>
      </div>
    </vue-modal>
  </div>
</template>

<script>
import moment from 'moment'
/* eslint-disable */
export default {
  props: ['passes'],
  methods: {
    getFormattedDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
  },
}
</script>
